import Box from "@mui/material/Box";
import useRolePermission from "entities/auth/hooks/useRolePermission";
import { ProductConfigurations } from "entities/products/types";
import { useStudiosPage } from "modules/studios/context";
import { FC, useEffect, useState } from "react";
import Drawer from "shared/components/Drawer";
import ContentSection from "shared/components/Drawer/components/ContentSection";
import { ArrowBackIcon } from "shared/theme/icons/ArrowBack";
import { useStudioDetails } from "../../context";
import { StyledButton } from "../../styled";
import ConfigItem, { ConfigItemProps } from "./components/ConfigItem";
import { StyledConfigs } from "./styled";

const ProductDetails: FC = () => {
  const { productDetailsDrawer } = useStudiosPage();
  const { setProductConfigs, productConfigs } = useStudioDetails();
  const [currentConfigs, setCurrentConfigs] = useState<
    ProductConfigurations | undefined
  >(undefined);
  const writeAccess = useRolePermission("studios:write");

  useEffect(() => {
    if (productDetailsDrawer.drawerDetails?.id && productConfigs) {
      setCurrentConfigs(productConfigs[productDetailsDrawer.drawerDetails?.id]);
    }
  }, [productConfigs, productDetailsDrawer.drawerDetails?.id]);

  const createHandleToggle = (key: keyof ProductConfigurations) => () => {
    setCurrentConfigs((prev) => prev && { ...prev, [key]: !prev[key] });
  };

  const configList: ConfigItemProps[] = [
    {
      title: "Game description",
      value: currentConfigs?.gameDescription,
      handleToggle: createHandleToggle("gameDescription"),
    },
    {
      title: "Features",
      value: currentConfigs?.features,
      handleToggle: createHandleToggle("features"),
    },
    {
      title: "Game information",
      value: currentConfigs?.gameInformation,
      handleToggle: createHandleToggle("gameInformation"),
    },
  ];

  const onCloseProductDetails = () => {
    productDetailsDrawer.closeDrawer();
    setCurrentConfigs(undefined);
  };

  const handleProductDetailsSave = () => {
    const productId = productDetailsDrawer.drawerDetails?.id;

    if (productId && currentConfigs) {
      setProductConfigs((prev) => ({
        ...prev,
        [productId]: currentConfigs,
      }));
      onCloseProductDetails();
    }
  };

  return (
    <Drawer
      title={productDetailsDrawer.drawerDetails?.name}
      isOpen={productDetailsDrawer.isOpen}
      onCloseDrawer={onCloseProductDetails}
      width={640}
      Icon={ArrowBackIcon}
      headingRight={
        writeAccess.allowed && (
          <Box>
            <StyledButton
              title="Save"
              size="small"
              onClick={handleProductDetailsSave}
            />
          </Box>
        )
      }
    >
      <ContentSection title="Product Configuration">
        <StyledConfigs>
          {configList.map((config) => (
            <ConfigItem {...config} key={config.title} />
          ))}
        </StyledConfigs>
      </ContentSection>
    </Drawer>
  );
};

export default ProductDetails;
